/** List of known extension keys on the task */ export var TaskExtensionKeys = /*#__PURE__*/ function(TaskExtensionKeys) {
    /** Service understood legacy data from basic tasks */ TaskExtensionKeys["legacyData"] = "LegacyData";
    /** Copilot extension data */ TaskExtensionKeys["copilot"] = "copilot";
    /** ToDo extensions */ TaskExtensionKeys["todo"] = "todo";
    /** Copilot workflow extensions */ TaskExtensionKeys["marsCopilotProperties"] = "mars_planner_microsoft_CopilotProperties";
    /** Output details from the workflow api */ TaskExtensionKeys["marsLoopDetails"] = "mars_planner_microsoft_LoopDetails";
    return TaskExtensionKeys;
}({});
/**
 * List of known extension keys for the task personal view
 */ export var TaskPersonalViewExtensionKeys = /*#__PURE__*/ function(TaskPersonalViewExtensionKeys) {
    /** Service understood legacy data from basic tasks */ TaskPersonalViewExtensionKeys["legacyData"] = "LegacyData";
    return TaskPersonalViewExtensionKeys;
}({});
/**
 * List of known extension keys for the plan view
 */ export var TaskPlanViewExtensionKeys = /*#__PURE__*/ function(TaskPlanViewExtensionKeys) {
    /** Service understood legacy data from basic plans */ TaskPlanViewExtensionKeys["legacyData"] = "LegacyData";
    return TaskPlanViewExtensionKeys;
}({});
